<div class="step-invoice-data">
  <div class="step-header">
    <div>
      <h3>Dados de Faturamento</h3>
      <p class="step-subtitle">
        Configure as informações que serão aplicadas a todas as faturas geradas
        neste processo. Vencimento padrão é opcional — quando vazio, cada
        cliente usa seu vencimento individual (dia cadastrado + mês/ano
        informados abaixo).
      </p>
    </div>
  </div>

  <div class="form-card highlight-card">
    <label class="check-row primary">
      <p-checkbox [binary]="true" [(ngModel)]="skipInvoiceGeneration"></p-checkbox>
      <div class="check-text">
        <strong>Não gerar faturas (somente pedidos)</strong>
        <small>
          Quando marcado, o processo registra os pedidos mas <em>não</em> gera
          as faturas correspondentes. A emissão pode ser feita depois pela tela de faturas.
        </small>
      </div>
    </label>
  </div>

  <div class="form-card" [class.disabled]="skipInvoiceGeneration">
    <h4>Datas</h4>
    <div class="form-row">
      <div class="form-field">
        <label>
          <span>Data de emissão</span>
          <span class="required">*</span>
        </label>
        <p-calendar [(ngModel)]="referenceDate"
          dateFormat="dd/mm/yy" appendTo="body" [showIcon]="true"
          [disabled]="skipInvoiceGeneration"
          placeholder="dd/mm/aaaa"></p-calendar>
      </div>

      <div class="form-field">
        <label>
          <span>Data de competência</span>
          <span class="required">*</span>
        </label>
        <p-calendar [(ngModel)]="competenceDate"
          dateFormat="dd/mm/yy" appendTo="body" [showIcon]="true"
          [disabled]="skipInvoiceGeneration"
          placeholder="dd/mm/aaaa"></p-calendar>
        <small class="hint">Mês de referência fiscal da nota.</small>
      </div>

      <div class="form-field">
        <label>
          <span>Vencimento padrão</span>
        </label>
        <p-calendar [(ngModel)]="dueDate"
          dateFormat="dd/mm/yy" appendTo="body" [showIcon]="true" [showButtonBar]="true"
          [disabled]="skipInvoiceGeneration"
          placeholder="usar vencimento do cliente"></p-calendar>
        <small class="hint">
          Opcional — quando vazio, usa o dia individual do cliente com o mês/ano abaixo.
        </small>
      </div>
    </div>

    <div class="form-row" *ngIf="!dueDate">
      <div class="form-field">
        <label>
          <span>Mês do vencimento individual</span>
          <span class="required">*</span>
        </label>
        <p-dropdown [options]="monthOptions" [(ngModel)]="dueDateMonth"
          optionLabel="label" optionValue="value" appendTo="body"
          [disabled]="skipInvoiceGeneration"
          placeholder="Selecione"></p-dropdown>
      </div>

      <div class="form-field">
        <label>
          <span>Ano do vencimento individual</span>
          <span class="required">*</span>
        </label>
        <p-dropdown [options]="yearOptions" [(ngModel)]="dueDateYear"
          optionLabel="label" optionValue="value" appendTo="body"
          [disabled]="skipInvoiceGeneration"
          placeholder="Selecione"></p-dropdown>
        <small class="hint">
          O cliente só tem o dia cadastrado — o sistema monta a data juntando esse mês/ano com o dia do cliente.
        </small>
      </div>
    </div>
  </div>

  <div class="form-card" [class.disabled]="skipInvoiceGeneration">
    <h4>Opções de geração</h4>
    <div class="form-row checks">
      <label class="check-row">
        <p-checkbox [binary]="true" [(ngModel)]="separatelyByOrder"
          [disabled]="skipInvoiceGeneration"></p-checkbox>
        <div class="check-text">
          <strong>Gerar fatura separada por pedido</strong>
          <small>
            Quando marcado, cada pedido vira uma fatura distinta para o cliente.
            Caso contrário, todos os pedidos do mesmo cliente são consolidados em
            uma única fatura.
          </small>
        </div>
      </label>

      <label class="check-row">
        <p-checkbox [binary]="true" [(ngModel)]="autoSendEmail"
          [disabled]="skipInvoiceGeneration"></p-checkbox>
        <div class="check-text">
          <strong>Enviar e-mail automaticamente após a geração</strong>
          <small>Dispara o envio do PDF/boleto pra cada cliente assim que a fatura é criada.</small>
        </div>
      </label>

      <label class="check-row">
        <p-checkbox [binary]="true" [(ngModel)]="generateBoletos"
          (onChange)="onToggleGenerateBoletos()"
          [disabled]="skipInvoiceGeneration"></p-checkbox>
        <div class="check-text">
          <strong>Gerar boletos automaticamente</strong>
          <small>Solicita o boleto bancário junto com a fatura. Depende da integração configurada.</small>
        </div>
      </label>
    </div>
  </div>

  <div class="form-card" *ngIf="generateBoletos && !skipInvoiceGeneration">
    <h4>Carteira de cobrança por grupo</h4>
    <p class="card-subtitle">
      Cada grupo de faturamento usado pelos clientes selecionados recebe uma
      carteira de cobrança própria. A escolha aqui é aplicada ao gerar os boletos.
    </p>

    <div class="loading-state" *ngIf="loadingGroups || loadingPortfolios">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Carregando…</span>
    </div>

    <div class="empty-groups" *ngIf="!loadingGroups && groupRows.length === 0">
      <i class="pi pi-info-circle"></i>
      <span>Nenhum cliente selecionado tem grupo de faturamento definido.</span>
    </div>

    <table class="groups-table" *ngIf="!loadingGroups && groupRows.length > 0">
      <thead>
        <tr>
          <th>Grupo</th>
          <th style="width: 110px; text-align: right">Clientes</th>
          <th style="width: 360px">Carteira de cobrança</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of groupRows" [class.missing]="!row.billingPortfolioId">
          <td>{{ row.groupName }}</td>
          <td style="text-align: right">{{ row.customerCount }}</td>
          <td>
            <p-dropdown [options]="portfolioOptions" [(ngModel)]="row.billingPortfolioId"
              optionLabel="label" optionValue="value" appendTo="body"
              [filter]="true" filterPlaceholder="Buscar carteira"
              placeholder="Selecione a carteira" [showClear]="false">
            </p-dropdown>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="step-actions">
    <button pButton type="button" class="easymarine secondary"
      icon="pi pi-arrow-left" label="Anterior"
      [disabled]="saving" (click)="back.emit()"></button>
    <button pButton type="button" class="easymarine primary"
      icon="pi pi-arrow-right" iconPos="right" label="Próximo"
      [disabled]="!isValid() || saving" (click)="proximo()"></button>
  </div>
</div>
